module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4cpA1"))).then(() => parcelRequire('37nVf'));